import { render, staticRenderFns } from "./InformationLabelsModal.vue?vue&type=template&id=cff6e960&"
import script from "./InformationLabelsModal.vue?vue&type=script&lang=ts&"
export * from "./InformationLabelsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports